import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from '../../auth/services/auth.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const currentUser = this.auth.getCurrentUser();

    const currentRole = currentUser.roles[0];
    const allowedRoles = route.data['allowedRoles'] as string[];

    // If no roles are set in the route, allow by default
    if (!allowedRoles || allowedRoles.length === 0) {
      return true;
    }

    if (allowedRoles.includes(currentRole)) {
      return true;
    }

    // If not allowed, redirect or show error
    this.router.navigate(['/home']);
    return false;
  }
}
